import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@mui/material/Link';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import MailIcon from '@mui/icons-material/Mail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LanguageIcon from '@mui/icons-material/Language';
import './styles/contact.css';

export const Contact = ({ darkMode }) => {
  const contactLinks = [
    {
      icon: <MailIcon className={darkMode ? "contact-icon-dark" : "contact-icon-light"} />,
      label: "hernanpesantez@me.com",
      url: "mailto:hernanpesantez@me.com",
    },
    {
      icon: <LinkedInIcon className={darkMode ? "contact-icon-dark" : "contact-icon-light"} />,
      label: "linkedin.com/in/hernan-pesantez",
      url: "https://www.linkedin.com/in/hernan-pesantez-856aba2b/",
    },
    {
      icon: <GitHubIcon className={darkMode ? "contact-icon-dark" : "contact-icon-light"} />,
      label: "github.com/hernanpesantez",
      url: "https://github.com/hernanpesantez/",
    },
    {
      icon: <LanguageIcon className={darkMode ? "contact-icon-dark" : "contact-icon-light"} />,
      label: "hernan.io",
      url: "https://hernan.io",
    },
    {
      icon: <LocationOnIcon className={darkMode ? "contact-icon-dark" : "contact-icon-light"} />,
      label: "New York, NY",
      url: null,
    },
  ];

  return (
    <Container className={darkMode ? 'container-dark' : 'container-light'}>

      <Box className="contact-header" sx={{ pt: 6, pb: 2 }}>
        <Typography variant="h4" className={`contact-title ${darkMode ? 'text-dark' : 'text-light'}`}>
          Get in Touch
        </Typography>
        <Typography variant="body1" className={`contact-subtitle ${darkMode ? 'card-text-dark' : ''}`}>
          I'm always open to discussing new opportunities, interesting projects, or just connecting. Feel free to reach out through any of the channels below.
        </Typography>
      </Box>

      <Box className="contact-links-container">
        {contactLinks.map((item, index) => (
          <Box key={index} className={`contact-link-row ${darkMode ? 'contact-row-dark' : 'contact-row-light'}`}>
            {item.icon}
            {item.url ? (
              <Link
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className={darkMode ? 'contact-link-dark' : 'contact-link-light'}
                underline="hover"
              >
                {item.label}
              </Link>
            ) : (
              <Typography className={darkMode ? 'contact-label-dark' : 'contact-label-light'}>
                {item.label}
              </Typography>
            )}
          </Box>
        ))}
      </Box>

    </Container>
  );
};
